import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "main_body"
}
const _hoisted_2 = {
  key: 0,
  class: "upload_body"
}
const _hoisted_3 = { class: "icon" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text" }, "上传evms文件", -1)
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", null, "重新选择", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 是否确认删除当前的evms曲谱文件？ ")

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_UploadOutlined = _resolveComponent("UploadOutlined")
  const _component_a_upload = _resolveComponent("a-upload")
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")
  const _component_a_descriptions = _resolveComponent("a-descriptions")
  const _component_a_tooltip = _resolveComponent("a-tooltip")
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")
  const _component_a_space = _resolveComponent("a-space")
  const _component_a_modal = _resolveComponent("a-modal")
  const _component_a_card = _resolveComponent("a-card")

  return (_openBlock(), _createBlock(_component_a_card, {
    class: "upload_card",
    hoverable: "",
    onMouseenter: $setup.handleMouseEnter,
    onMouseleave: $setup.handleMouseLeave
  }, {
    default: _withCtx(() => [
      ($setup.hasSheet)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            ($setup.isHover)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_a_upload, {
                    class: "upload_icon",
                    accept: ".evms",
                    "before-upload": $setup.handleBeforeUpload
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_UploadOutlined, {
                          style: _normalizeStyle({ color: $setup.store.state.themeColor })
                        }, null, 8, ["style"])
                      ]),
                      _hoisted_4
                    ]),
                    _: 1
                  }, 8, ["before-upload"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_a_descriptions, {
                    title: "曲谱文件",
                    bordered: "",
                    column: 3
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_descriptions_item, {
                        label: "曲谱文件地址",
                        span: 3
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.formData.evms_file_url || "请上传evms文件"), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_descriptions_item, {
                        label: "曲谱文件MD5",
                        span: 3
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.formData.evms_file_md5 || "请上传evms文件"), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_descriptions_item, {
                        label: "曲谱文件大小",
                        span: 3
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.formData.evms_file_size || "请上传evms文件"), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_a_descriptions, {
              title: "曲谱文件",
              bordered: "",
              column: 3
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_descriptions_item, {
                  label: "曲谱文件地址",
                  span: 3
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_tooltip, null, {
                      title: _withCtx(() => [
                        _createTextVNode(_toDisplayString($setup.formData.evms_file_url), 1)
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" " + _toDisplayString($setup.formData.evms_file_url.length > 40
                ? $setup.formData.evms_file_url.substr(0, 40) + "..."
                : $setup.formData.evms_file_url), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, {
                  label: "曲谱文件MD5",
                  span: 3
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($setup.formData.evms_file_md5), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, {
                  label: "曲谱文件大小",
                  span: 3
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_space, null, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString($setup.formData.evms_file_size), 1),
                        _createVNode(_component_a_upload, {
                          showUploadList: false,
                          accept: ".evms,.musicxml",
                          "before-upload": $setup.handleBeforeUpload
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_UploadOutlined, {
                              style: _normalizeStyle({ color: $setup.store.state.themeColor })
                            }, null, 8, ["style"]),
                            _hoisted_7
                          ]),
                          _: 1
                        }, 8, ["before-upload"]),
                        _createElementVNode("a", {
                          onClick: _cache[0] || (_cache[0] = (...args) => ($setup.showDeleteModal && $setup.showDeleteModal(...args)))
                        }, [
                          _createVNode(_component_DeleteOutlined),
                          _hoisted_8
                        ])
                      ]),
                      _: 1
                    }),
                    ($setup.deleteVisible)
                      ? (_openBlock(), _createBlock(_component_a_modal, {
                          key: 0,
                          title: "警告",
                          visible: $setup.deleteVisible,
                          maskClosable: false,
                          okText: "确定",
                          cancelText: "取消",
                          onOk: $setup.handleDeleteSheet,
                          onCancel: $setup.handleDeleteCancel
                        }, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 1
                        }, 8, ["visible", "onOk", "onCancel"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
    ]),
    _: 1
  }, 8, ["onMouseenter", "onMouseleave"]))
}